import { render, staticRenderFns } from "./EstoqueItemList.vue?vue&type=template&id=1da4e3dc&"
import script from "./EstoqueItemList.vue?vue&type=script&lang=js&"
export * from "./EstoqueItemList.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueItemList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports